export const storeProductQueryPosition = (
  productId: number,
  queryPosition: number
): void => {
  const payload = { product_id: productId, query_position: queryPosition }
  const data = window.btoa(JSON.stringify(payload))

  document.cookie = `_laced_asqp=${data}; expires=; path=/`
}
